import * as serviceContext from '../services/serviceContext';
import { BASE_URL_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function dashboardDetails(){
    try {
        const response = await serviceContext.get(`${BASE_URL_ADMIN}manage/dashboard/admin`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateDashboardTimezone(data){
    try {
        const response = await serviceContext.post(`${BASE_URL_ADMIN}manage/dashboard`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}